var exports = {
  "kL": "TextualAttachmentPreviewBottomSheet.module__container___Z3B2dk",
  "Hy": "TextualAttachmentPreviewBottomSheet.module__codeContainer___Z3B2dk",
  "Dy": "TextualAttachmentPreviewBottomSheet.module__codeSurface___Z3B2dk",
  "qr": "TextualAttachmentPreviewBottomSheet.module__footer___Z3B2dk",
  "qt": "TextualAttachmentPreviewBottomSheet.module__fileSection___Z3B2dk",
  "gM": "TextualAttachmentPreviewBottomSheet.module__fileMeta___Z3B2dk",
  "Md": "TextualAttachmentPreviewBottomSheet.module__fileName___Z3B2dk",
  "Ov": "TextualAttachmentPreviewBottomSheet.module__fileSize___Z3B2dk",
  "zt": "TextualAttachmentPreviewBottomSheet.module__footerActions___Z3B2dk",
  "hP": "TextualAttachmentPreviewBottomSheet.module__actionButton___Z3B2dk" + " " + __webpack_require__(180357)["AS"],
};

module.exports = exports;
